module.exports = __webpack_public_path__ + "static/img/B01-辽宁省实验学校.f11d277.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schoolImg/B01-辽宁省实验学校.png
// module id = LNfl
// module chunks = 0